module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jLzZJ"))).then(() => module.bundle.root('iDabs'));